import { render, staticRenderFns } from "./IActionsMenu.vue?vue&type=template&id=f55bd9c6"
import script from "./IActionsMenu.vue?vue&type=script&lang=js"
export * from "./IActionsMenu.vue?vue&type=script&lang=js"
import style0 from "./IActionsMenu.vue?vue&type=style&index=0&id=f55bd9c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports